import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

import { api } from '@/utils/api';

import { NavItem } from './Navigation';
import NavigationSubMenu from './NavigationSubMenu';

const VibecodeMenu: FC<{ navItem: NavItem }> = ({ navItem }) => {
  const { data } = useQuery({
    queryKey: ['vibebone_nav_items'],
    queryFn: () =>
      api.get<never, Array<{ name: string; link: string }>>(
        '/v1/vibecode-nav-items',
      ),
    staleTime: Infinity,
  });

  return (
    <NavigationSubMenu
      navItem={{
        ...navItem,
        navItems:
          data?.map((item, index) => ({
            to: index === 0 ? 'vibebone' : `vibebone/${index}`,
            end: true,
            title: item.name,
            general: true,
          })) ?? [],
      }}
    />
  );
};

export default VibecodeMenu;
